import React, {Fragment} from 'react'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'

// Custom Style
import {oceanBlueColor, orangeColor} from '../../styles/jss/cmsMainStyle'
import {saveWarnDialogStyle} from '../../styles/jss/components/dialog/saveWarnDialogStyle'

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />
})

const useStyles = makeStyles(theme => saveWarnDialogStyle(theme))

const SaveDialog = props => {
	const classes = useStyles()
	const {open, dialogTitle, dialogContent, saveAction, dontSaveAction, cancelAction} = props

	return (
		<Fragment>
			<Dialog
				open={open}
				TransitionComponent={Transition}
				fullWidth={true}
				// onClose={handleClose}
				aria-labelledby="confirmDialogTitle"
				aria-describedby="confirmDialogDescription"
				PaperProps={{
					style: {
						background:	"linear-gradient(0deg, " + orangeColor[2] + ", " + orangeColor[0] + ")",
					},
				}}
			>
				<DialogTitle id="confilmDialogTitle">
					{dialogTitle}
				</DialogTitle>

				<DialogContent>
					<DialogContentText id="confirmDialogContent" className={classes.content}>
						{dialogContent}
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button onClick={cancelAction} className={classes.actionButton} autoFocus>
						Cancel
					</Button>

					<Button onClick={dontSaveAction} className={classes.actionButton}>
						Don't Save
					</Button>

					<Button onClick={saveAction} className={classes.actionButton}>
						Save
					</Button>
				</DialogActions>

			</Dialog>
		</Fragment>
	)
}


export default SaveDialog
